import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'
import { vmCreatePath, vmEditPath, vmDetailPath } from 'routes'
import { ProcurementContainer, ProcurementBody } from 'routes/ProcurementSystem/styled'
import { PRListCont } from './styled'
import { fetchVM } from 'ducks/vendorMaintenance'
import { columns } from './AttributeData'
import { MainBodyContent, CustomButton, SearchList, TablePagination } from 'components'

// import r from 'reactotron-react-js'

const PurchaseRequisition = (props) => {
  const { vendorMaintenances, listLoading, valueForm } = props
  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(() => {
    window.scrollTo(0, 0)
    props.fetchVM({ page: 1, size: pageSize })
  }, [])

  return (
    <MainBodyContent headerTitle='Vendor Maintenance'
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(vmCreatePath)}
            icon='plus'
            btnColor='gray'
            title='Create' />
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList 
            placeholder='Doc No., Title, Requester, Vendor Code or Vendor Name' 
            fetchAPI={props.fetchVM} 
            formSearchName='formSearchVendorMaintenance' 
            filterDate 
            filterStatus 
            hideProject={true}
            pageSize={userPageSize}
          />
          <PRListCont>
            <ReactTable
              data={Object.keys(vendorMaintenances).length > 0 ? vendorMaintenances.data : []}
              columns={columns.list}
              defaultPageSize={userPageSize}
              noDataText='No data vendor maintenance request.'
              previousText={<Icon name='arrow alternate circle left' />}
              nextText={<Icon name='arrow alternate circle right' />}
              className='-striped -highlight'

              PaginationComponent={TablePagination}
              pages={Object.keys(vendorMaintenances).length > 0 ? vendorMaintenances.totalPage : 0}
              currentPage={Object.keys(vendorMaintenances).length > 0 ? vendorMaintenances.page : 0}
              onPageChange={(pageIndex) => {
                props.fetchVM({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.fetchVM({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      if ([0, 5,10,11].indexOf(Number(rowInfo.original.status)) >= 0) {
                        window.open(vmEditPath(rowInfo.original.id), '_blank')
                        // props.history.push(vmEditPath(rowInfo.original.id))
                      } else {
                        window.open(vmDetailPath(rowInfo.original.id), '_blank')
                        // props.history.push(vmDetailPath(rowInfo.original.id))
                      }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </PRListCont>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => ({
  valueForm: getFormValues('formSearchVendorMaintenance')(state),
  vendorMaintenances: state.vendorMaintenance.listVendorMaintenance.data,
  listLoading: state.vendorMaintenance.listVendorMaintenance.loading
})

const mapDispatchToProps = {
  fetchVM
}

const contForm = reduxForm({
  form: 'formSearchVendorMaintenance',
  enableReinitialize: true,
})(PurchaseRequisition)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)